// EmailJS 설정
export const emailjsConfig = {
  serviceId: process.env.REACT_APP_EMAILJS_SERVICE_ID || 'service_default',
  templateId: process.env.REACT_APP_EMAILJS_TEMPLATE_ID || 'template_default',
  publicKey: process.env.REACT_APP_EMAILJS_PUBLIC_KEY || 'public_key_default'
};

// 이메일 템플릿 변수 매핑
export const templateParams = {
  to_name: '{{to_name}}',
  to_email: '{{to_email}}', 
  subject: '{{subject}}',
  message: '{{message}}',
  mold_number: '{{mold_number}}',
  mold_name: '{{mold_name}}',
  current_shots: '{{current_shots}}',
  design_life: '{{design_life}}',
  lifetime_percentage: '{{lifetime_percentage}}'
};
